import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { generateSatisfactionMetrics } from '../../utilityFunctions/DataloveUtil';
import Swal from 'sweetalert';
import CustomLoader from "../../components/CustomLoader";

export default function SatisfactionChart(props) {
    const { loginUser } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [averageScore, setAverageScore] = useState(0);

    useEffect(() => {
        const fetchSatisfactionMetrics = async () => {
            setLoading(true);
            const satisfactionMetrics = await generateSatisfactionMetrics(loginUser.jwtToken);
            setLoading(false);

            if (!satisfactionMetrics) {
                Swal({
                    title: "Error",
                    text: "Failed to fetch satisfaction metrics",
                    icon: "error",
                    button: "Ok",
                });
                return;
            }

            // Calculate average NPS score
            const avg = satisfactionMetrics.averageScore || 0;
            setAverageScore(avg);

            // Create data for gauge chart
            const gaugeData = [
                { name: 'Score', value: avg },
                { name: 'Remaining', value: 10 - avg }
            ];

            setData(gaugeData);
        };
        fetchSatisfactionMetrics();
    }, [loginUser.jwtToken]);

    // Colors for the gauge
    const COLORS = ['#01929b', '#f5f5f5'];

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
                {loading ? (
                    <CustomLoader />
                ) : (
                    <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ marginTop: "2rem", fontWeight: "bold" }}>Satisfaction Score</Typography>
                        </Grid>
                        {data && data.length > 0 ? (
                            <Grid item xs={12} sx={{width: "100%", height: 400}}>
                                <ResponsiveContainer width="100%" height={400}>
                                    <PieChart>
                                        <Pie
                                            data={data}
                                            cx="50%"
                                            cy="50%"
                                            startAngle={180}
                                            endAngle={0}
                                            innerRadius="60%"
                                            outerRadius="80%"
                                            paddingAngle={0}
                                            dataKey="value"
                                        >
                                            {data.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <Tooltip formatter={(value, name) => {
                                            if (name === 'Score') {
                                                return [`${value.toFixed(1)} / 10`, 'Average Satisfaction'];
                                            }
                                            return [null, ''];
                                        }} />
                                    </PieChart>
                                </ResponsiveContainer>
                                <Typography variant="h3" sx={{ marginTop: "-12rem", color: "#01929b", fontWeight: "bold" }}>
                                    {averageScore.toFixed(1)}
                                </Typography>
                                <Typography variant="h6" sx={{ marginTop: "0.5rem" }}>
                                    Average Satisfaction Score
                                </Typography>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    No data available.
                                </Typography>                                
                            </Grid>
                        )}
                    </Grid>
                )}           
            </Box>
        </Box>
    );
} 